module.exports = __webpack_public_path__ + "img/load_room.37f20f0d.png";